/* eslint-disable  */

import { DefaultRoute } from "../router/routes";

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = (obj) => Object.keys(obj).length === 0;

// ** Returns K format from a number
export const kFormatter = (num) =>
  num > 999 ? `${(num / 1000).toFixed(1)}k` : num;

// ** Converts HTML to string
export const htmlToString = (html) => html.replace(/<\/?[^>]+(>|$)/g, "");

// ** Checks if the passed date is today
const isToday = (date) => {
  const today = new Date();
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (
  value,
  formatting = { month: "short", day: "numeric", year: "numeric" }
) => {
  if (!value) return value;
  return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value);
  let formatting = { month: "short", day: "numeric" };

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: "numeric", minute: "numeric" };
  }

  return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem("userData");
export const getUserData = () => JSON.parse(localStorage.getItem("userData"));

export const hasPermission = (permission) => {
  const userData = getUserData();
  if (userData?.roleID?.key === permission) {
    return true;
  }
  return false;
};
// [
//   {
//       "id": "654d292596cd640b0734f7e6",
//       "name": "Admin Executive Assistant",
//       "inOffice": true,
//       "key": "AdminExecutiveAssistant"
//   },
//   {
//       "id": "654d292596cd640b0734f7f2",
//       "name": "Sales Agent",
//       "inOffice": false,
//       "key": "saleAgent"
//   },
//   {
//       "id": "654d292596cd640b0734f7f9",
//       "name": "Inventory Employee",
//       "inOffice": true,
//       "key": "InventoryEmployee"
//   },
//   {
//       "id": "654d292596cd640b0734f81d",
//       "name": "Relations Employee",
//       "inOffice": true,
//       "key": "RelationsEmployee"
//   },
//   {
//       "id": "654d292596cd640b0734f814",
//       "name": "Logistics Employee",
//       "inOffice": true,
//       "key": "LogisticEmployee"
//   },
//   {
//       "id": "654d292596cd640b0734f804",
//       "name": "Programmer",
//       "inOffice": true,
//       "key": "programmer"
//   },
//   {
//       "id": "654d292596cd640b0734f825",
//       "name": "Accounting Employee",
//       "inOffice": true,
//       "key": "Accounting"
//   },
//   {
//       "id": "654d292596cd640b0734f82d",
//       "name": "Owner",
//       "inOffice": true,
//       "key": "owner"
//   },
//   {
//       "id": "654d292596cd640b0734f83d",
//       "name": "Sales Manager",
//       "inOffice": true,
//       "key": "salesManager"
//   },
//   {
//       "id": "654d292596cd640b0734f847",
//       "name": "Recruiter User",
//       "inOffice": false,
//       "key": "RecruiterUser"
//   },
//   {
//       "id": "654d292596cd640b0734f845",
//       "name": "Driver",
//       "inOffice": false,
//       "key": "Driver"
//   },
//   {
//       "id": "654d292596cd640b0734f84f",
//       "name": "Sales Assistant",
//       "inOffice": false,
//       "key": "saleAssistant"
//   },
//   {
//       "id": "654d292596cd640b0734f856",
//       "name": "Container Expert",
//       "inOffice": false,
//       "key": "containerExpert"
//   }
// ]
export const hasManyPermission = (permissions) => {
  const userData = getUserData();

  if (userData && userData.roleID && userData.roleID.key) {
    const userRole = userData.roleID.key;

    if (Array.isArray(permissions)) {
      return permissions.includes(userRole);
    } else {
      // Handle the case where permissions is not an array
      return false;
    }
  }

  return false;
};

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = (userRole) => {
  if (userRole === "client") return "/access-control";
  if (userRole) {
    // if (userRole === "owner") {
    return DefaultRoute;
    // } else {
    //   return "/pages/welcome";
    // }
  }
  return "/login";
};

// ** React Select Theme Colors
export const selectThemeColors = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: "#7367f01a", // for option hover bg-color
    primary: "#7367f0", // for selected option bg-color
    neutral10: "#7367f0", // for tags bg-color
    neutral20: "#ededed", // for input border-color
    neutral30: "#ededed", // for input hover border-color
  },
});
